import React from "react"

const BookIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
  </svg>
)

const Report = () => {
  return (
    <>
      <div className="report-content">
        <div className="container">
          <div className="report-row">
            {/* <Fade triggerOnce>
              <a
                href="/documents/survey-participant-information-sheet-for-lawyers.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="report-download"
              >
                <BookIcon />
                <span>2026 Report</span>
              </a>
            </Fade> */}
          </div>
        </div>
      </div>
    </>
  )
}

export default Report
